import React from 'react';

function StateDraft() {
  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 9.26758C0 4.29702 4.02944 0.267578 9 0.267578C13.9706 0.267578 18 4.29702 18 9.26758C18 14.2381 13.9706 18.2676 9 18.2676C4.02944 18.2676 0 14.2381 0 9.26758Z"
        fill="#E7E7E7"
      />
      <path
        d="M11.7412 7.91312L10.3541 6.52641L10.9091 5.97173C11.1563 5.7246 11.7223 5.67556 12.0185 5.97173L12.2958 6.24907C12.592 6.54524 12.5434 7.1113 12.2958 7.35883L11.7412 7.91312ZM11.1865 8.4682L7.30292 12.3518L5.5 12.7676L5.91582 10.9647L9.79938 7.0811L11.1865 8.4682Z"
        fill="#5E6F72"
      />
    </svg>
  );
}

export default StateDraft;
